module.exports = __webpack_public_path__ + "media/images/v2/header-5-cfea9de35554ba6cb1e38e04d832e1ac.png";